import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-logistic-import',
    templateUrl: './header-logistic-import.component.html',
    styleUrls: ['./header-logistic-import.component.scss'],
})
export class HeaderLogisticImportComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    goToHome() {
        window.location.href = '/';
    }
}
